import Insert from './insert.dialog'
import { mailTemplate, mailLetterFamily } from '@/api/mail'
import operation from '@/api/operation'
export default {
  components: { Insert },
  data() {
    return {
      rules: {},
      params: {
        letterFamilyId: '',
        fromMail: '',
        toJournal: false,
        toManageEditor: false,
        toOther: false,
        toOtherMail: '',
        toDisplay: false,
        toFirstEditor: false,
        toProcessEditor: false,
        toReviewer: false,
        toEditorBoard: false,
        toGuestEditor: false,
        toEmployee: false,
        toCorrAuthor: false,
        toCoAuthor: false,
        toSubmitter: false,
        toOperator: false,
        replyTo: '',
        ccCoAuthor: false,
        ccManageEditor: false,
        ccProcessEditor: false,
        ccJournal: false,
        ccOther: false,
        ccOtherMail: '',
        ccDisplay: false,
        bccCoAuthor: false,
        bccManageEditor: false,
        bccProcessEditor: false,
        bccJournal: false,
        bccOther: false,
        bccOtherMail: '',
        bccDisplay: false,
        allowAttach: false,
        toSpecialApplicator: false,
        toAllGuestEditor: false,
        toAllCoAuthor: false
      },
      familyList: [],
      showData: {
        fromSystem: true,
        fromJournal: true,
        toJournal: true,
        toManageEditor: true,
        toOther: true,
        toDisplay: true,
        toFirstEditor: true,
        toProcessEditor: true,
        toCurrentReviewer: true,
        toCorrAuthor: true,
        toCoAuthor: true,
        toSubmitter: true,
        toOperator: true,
        ccAllCoAuthor: true,
        ccManageEditor: true,
        ccProcessEditor: true,
        ccJournal: true,
        ccOther: true,
        ccDisplay: true,
        bccAllCoAuthor: true,
        bccManageEditor: true,
        bccProcessEditor: true,
        bccJournal: true,
        bccOther: true,
        bccDisplay: true,
        replyPublisher: true,
        replyJournal: true,
        allowAttach: true,
        toSpecialApplicator: false,
        toAllGuestEditor: false,
        toAllCoAuthor: false
      },
      oldData: {},
      show: false
    }
  },
  async mounted() {
    this.id = this.$route.params.id
    await this.getMailLetterFamily()
    if (this.id) {
      this.getQuery()
    }
  },
  methods: {
    async getQuery() {
      const data = await mailTemplate.query(this.id)
      this.oldData = JSON.parse(JSON.stringify(data))
      data.letterFamilyId = data.letterFamily.letterFamilyId
      this.params = data
      this.onChange(this.params.letterFamilyId)
    },
    async getMailLetterFamily() {
      this.familyList = await mailLetterFamily.getAll()
      this.params.letterFamilyId = this.familyList[0].id
      this.onChange(this.params.letterFamilyId)
    },
    insert() {
      this.show = true
    },
    confirm() {
      this.show = false
    },
    cancel() {
      this.show = false
    },
    async onChange(val) {
      this.showData = await mailLetterFamily.query(val)
    },
    async save(flag) {
      const data = Object.assign(
        this.params,
        flag
          ? {
              enabled: true
            }
          : {}
      )
      if (data.id) {
        const res = await mailTemplate.edit(data.id, data)
        const keys = {
          subject: `【Letter Subject】: Change from 【oldData】 to 【newData】;`,
          letterFamily: `【Letter Family】: Change from 【oldData】 to 【newData】;`,
          fromMail: `【Sender’s Email Address】: Change from 【oldData】 to 【newData】;`,

          toJournal: `【Recipient: Journal Email】: Change from 【oldData】 to 【newData】;`,
          toManageEditor: `【Recipient: Manager Editor】: Change from 【oldData】 to 【newData】;`,
          toOther: `【Recipient: Display the following e-mail address for the recipient】: Change from 【oldData】 to 【newData】;`,
          toOtherMail: `【Recipient: The following e-mail address for the recipient】: Change from 【oldData】 to 【newData】;`,
          toDisplay: `【Recipient: Display text box so sender can insert an e-mail address】: Change from 【oldData】 to 【newData】;`,
          toFirstEditor: `【Recipient: First Assigned Editor】: Change from 【oldData】 to 【newData】;`,
          toProcessEditor: `【Recipient: Assigned Editor】: Change from 【oldData】 to 【newData】;`,
          toReviewer: `【Recipient: All Reviewers of the current revision of the submission (Send it Seperately)】: Change from 【oldData】 to 【newData】;`,
          toEditorBoard: `【Recipient: Editorial Board】: Change from 【oldData】 to 【newData】;`,
          toAllGuestEditor: `【Recipient: Guest Editors (Send together)】: Change from 【oldData】 to 【newData】;`,
          toGuestEditor: `【Recipient: Guest Editors (spearate delivery)】: Change from 【oldData】 to 【newData】;`,
          toCorrAuthor: `【Recipient: Corresponding Author】: Change from 【oldData】 to 【newData】;`,
          toAllCoAuthor: `【Recipient: Co-Author (Send together)】: Change from 【oldData】 to 【newData】;`,
          toCoAuthor: `【Recipient: Co-Author (spearate delivery)】: Change from 【oldData】 to 【newData】;`,
          toEmployee: `【Recipient: Employee】: Change from 【oldData】 to 【newData】;`,
          toSubmitter: `【Recipient: Submitter】: Change from 【oldData】 to 【newData】;`,
          toOperator: `【Recipient: Operator】: Change from 【oldData】 to 【newData】;`,
          toSpecialApplicator: `【Recipient: Applicant for Special Issue】: Change from 【oldData】 to 【newData】;`,

          replyTo: `【Email for Reply】: Change from 【oldData】 to 【newData】;`,

          ccCoAuthor: `【Additional Recipients: Automatically CC: All Co-Authors】: Change from 【oldData】 to 【newData】;`,
          ccProcessEditor: `【Additional Recipients: Automatically CC: Assigned Editor】: Change from 【oldData】 to 【newData】;`,
          ccManageEditor: `【Additional Recipients: Automatically CC: Managing Editor】: Change from 【oldData】 to 【newData】;`,
          ccJournal: `【Additional Recipients: Automatically CC: Journal Email】: Change from 【oldData】 to 【newData】;`,
          bccCoAuthor: `【Additional Recipients: Automatically BCC: All Co-Authors】: Change from 【oldData】 to 【newData】;`,
          bccProcessEditor: `【Additional Recipients: Automatically BCC: Assigned Editor】: Change from 【oldData】 to 【newData】;`,
          bccManageEditor: `【Additional Recipients: Automatically BCC: Managing Editor】: Change from 【oldData】 to 【newData】;`,
          bccJournal: `【Additional Recipients: Automatically BCC: Journal Email】: Change from 【oldData】 to 【newData】;`,

          ccOther: `【Send Copies to the Following Address: CC】: Change from 【oldData】 to 【newData】;`,
          ccOtherMail: `【Send Copies to the Following Address: CC Display】: Change from 【oldData】 to 【newData】;`,
          bccOther: `【Send Copies to the Following Address: BCC】: Change from 【oldData】 to 【newData】;`,
          bccOtherMail: `【Send Copies to the Following Address: BCC Display】: Change from 【oldData】 to 【newData】;`,

          ccDisplay: `【Display email entry box on 'Send Letter' page: CC】: Change from 【oldData】 to 【newData】;`,
          bccDisplay: `【Display email entry box on 'Send Letter' page: BCC】: Change from 【oldData】 to 【newData】;`,

          allowAttach: `【Allowed Attachment】: Change from 【oldData】 to 【newData】;`,
          body: `【Letter Body】: Changed;`
        }
        let detail = ``
        Object.keys(keys).forEach(key => {
          if (JSON.stringify(this.oldData[key]) != JSON.stringify(res[key])) {
            if (key === 'letterFamily') {
              keys[key] = keys[key].replace(
                '【oldData】',
                `【${this.oldData.letterFamily.name}】`
              )
              keys[key] = keys[key].replace(
                '【newData】',
                `【${res.letterFamily.name}】`
              )
            } else {
              keys[key] = keys[key].replace(
                '【oldData】',
                `【${this.oldData[key] === null ? ' -- ' : this.oldData[key]}】`
              )
              keys[key] = keys[key].replace(
                '【newData】',
                `【${res[key] === null ? ' -- ' : res[key]}】`
              )
            }
            detail += `<div class="mar-b-10">${keys[key]}</div>`
          }
        })
        if (detail) {
          await operation.add({
            authorityCode: 'SYSTEM.MAIL.TEMPLATE.EDIT',
            type: 'EDIT',
            info: `Edit The Template: ${res.subject}`,
            detail
          })
        }
      } else {
        const res = await mailTemplate.add(data)
        await operation.add({
          authorityCode: 'SYSTEM.MAIL.TEMPLATE.ADD_NEW',
          type: 'ADD',
          info: `Add Template: ${res.subject} `,
          detail: `【Letter Subject】: ${res.subject}<br/>
          【Letter Family】: ${res.letterFamily.name}`
        })
      }
      this.$message.success({
        title: 'Success',
        content: `This Email Template has been ${flag ? 'published' : 'saved'}`
      })
      this.$router.back(-1)
    }
  }
}
